export class PopinManager {
    private popinRoot: HTMLElement;
    private popinButton: HTMLElement | null;
    private popinContainer: HTMLElement | null;
    private popinClose: HTMLElement | null;
    private popinContent: HTMLElement | null;

    constructor(root: HTMLElement) {
        this.popinRoot = root;
        this.popinButton = this.popinRoot.querySelector('.alert-popin__button');
        this.popinContainer = this.popinRoot.querySelector('.alert-popin__container');
        this.popinClose = this.popinRoot.querySelector('.alert-popin__close');
        this.popinContent = this.popinRoot.querySelector('.alert-popin__content');

        if (!this.popinButton || !this.popinContainer || !this.popinClose) return;
        this.init();
    }

    private init(): void {
        const cookieName = this.getCookieName();
        const currentVersion = this.getCurrentVersion();
        const lastSeenVersion = this.getCookie(cookieName);

        // On n'enregistre que la dernière version vue (par type de popin).
        // Si la version change (nouvelle alerte / retour à une ancienne), on ré-affiche.
        if (!lastSeenVersion || lastSeenVersion !== currentVersion) {
            this.setCookie(currentVersion);
            this.togglePopin(true);
        }
        this.addEventListeners();
    }

    private addEventListeners(): void {
        this.popinButton?.addEventListener('click', () => this.togglePopin(true));
        this.popinClose?.addEventListener('click', () => this.togglePopin(false));
        this.popinContainer?.addEventListener('click', () => this.togglePopin(false));
        this.popinContent?.addEventListener('click', (event) => event.stopPropagation());
    }

    private togglePopin(show: boolean): void {
        this.popinContainer?.classList.toggle('visible', show);
    }

    private setCookie(value: string): void {
        document.cookie = `${this.getCookieName()}=${encodeURIComponent(value)}; path=/; max-age=${60 * 60 * 24};`;
    }

    private getCookieName(): string {
        const kind = this.popinRoot?.dataset?.popinKind?.trim();
        // Ex: popupcookies_alert / popupcookies_info
        return `popupcookies_${kind || 'default'}`;
    }

    private getCurrentVersion(): string {
        // Si pas de version fournie, on retombe sur une valeur stable.
        return this.popinRoot?.dataset?.popinVersion?.trim() || '1';
    }

    private getCookie(name: string): string | undefined {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        return parts.length === 2 ? parts.pop()?.split(';').shift() : undefined;
    }
}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll<HTMLElement>('.alert-popin').forEach((root) => new PopinManager(root));
});